export const profile = {
  variant: import.meta.env.VITE_PROFILE ?? 'standart',
  isEraPremium: import.meta.env.VITE_PROFILE !== 'vsem',
  isShowNews: import.meta.env.VITE_PROFILE !== 'vsem',
  functionalAll: import.meta.env.VITE_PROFILE === 'vsem',
  isLogoEye: import.meta.env.VITE_PROFILE === 'vsem',
  isYandexMetric: import.meta.env.VITE_PROFILE !== 'vsem',
  isReferalLinkAndQRCode: import.meta.env.VITE_PROFILE !== 'vsem',
  isRegistrationSpecific: import.meta.env.VITE_PROFILE === 'vsem',
}
